import React, { useState } from "react";
import Button1 from "../../form/Button1";
import manualRefund from "../../../controllers/booking/postTicketing/refund/manualRefund";
import { formatMoney } from "../../../features/utils/formatMoney";
import StaffApiErrorModal, {
  getStaffApiErrorCopy,
} from "../StaffApiErrorModal";

export default function ManualRefund({ data, callback }) {
  const [loadings, setLoadings] = useState({ submit: false });
  const [apiError, setApiError] = useState(null);

  async function handleManual() {
    setLoadings({ ...loadings, submit: true });
    const res = await manualRefund(data?._id);
    setLoadings({ ...loadings, submit: false });
    if (res.return) {
      callback && callback();
    } else setApiError(getStaffApiErrorCopy(res));
  }

  return (
    <>
    <div className="flex flex-col gap-6">
      <div>
        <h5>Credit the agent wallet?</h5>
        <p>
          Only continue if the airline refund has succeeded. This credits the
          agent wallet with the quoted refund amount
          {data?.payable ? ` (${formatMoney(data.payable)})` : ""}. If the
          airline refund failed, decline the request instead — do not credit
          the wallet.
        </p>
      </div>
      <div className="flex gap-4">
        <div>
          <Button1 variant="outlined">Back</Button1>
        </div>
        <Button1 loading={loadings.submit} onClick={handleManual}>
          Credit wallet
        </Button1>
      </div>
    </div>
    <StaffApiErrorModal
      open={Boolean(apiError)}
      setOpen={(next) => {
        if (!next) setApiError(null);
      }}
      title={apiError?.title}
      text={apiError?.text}
    />
    </>
  );
}
